import { render, staticRenderFns } from "./IndividualContact.vue?vue&type=template&id=5c7d1ba4&scoped=true&"
import script from "./IndividualContact.vue?vue&type=script&lang=js&"
export * from "./IndividualContact.vue?vue&type=script&lang=js&"
import style0 from "./IndividualContact.vue?vue&type=style&index=0&id=5c7d1ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d1ba4",
  null
  
)

export default component.exports